import './scss/main.scss'
import Vue from 'vue'
import App from './App'
import router from './router'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import VueResource from 'vue-resource'
Vue.component('app-header', Header)
Vue.component('app-footer', Footer)

Vue.component('gain-slider', function (resolve) {
  require(['@/components/GainSlider'], resolve)
})

Vue.use(VueResource)
Vue.config.productionTip = false
Vue.http.options.root = 'http://gainvest.pl/wp-json/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js